import axios from "axios";

const API_BASE_URL =process.env.REACT_APP_HOST;


export const login = async ({ email, password }) => {

  const response = await axios.post(`${API_BASE_URL }/login`, {
    email,
    password,
  });

  return response.data;
};

export const authMe = async () => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/authme`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const getContactList = async ({ search = "", limit = 10, page = 1 } = {}) => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await axios.get(`${API_BASE_URL}/contacts-list`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
      params: {
        search,
        limit,
        page,
      },
    });
    return response.data; 
  } catch (error) {
    console.error("Failed to fetch contacts:", error);
    throw error;
  }
};


